import type { FaireProductEntity } from "../../entity_types/product";

export const p_hfs3m53mcg: FaireProductEntity = {
  token: "p_hfs3m53mcg",
  type: "product",
  name: "Cacti of the Desert Southwest 1000 Piece Linen Jigsaw Puzzle",
  brandToken: "b_2rys9jdptm",
  brandName: "Toynk",
  imageUrl:
    "https://cdn.faire.com/fastly/8a223b4eacb0a353509b20f43cd31a4924d6396d072541b5677f83fb87b5a444.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e742c10d8e8d141db3bc7cec132fef35edc45af70224e5dafd359d07b4578e3e.jpeg",
    "https://cdn.faire.com/fastly/bc41f83907a13c8120519686c54aacce8958fa40b780862295a201fb9f1bf10e.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Put your skills to the test with this entertaining 1000 piece jigsaw puzzle from MasterPieces! Linen finish on packaging and puzzle. A fun challenge that makes for an amazing display piece once completed. Puzzles are a fun activity to do alone or in a group, and make a great gift for all ages at birthdays and holidays!",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:22.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
